/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import services from '../Service';

var screenCode = "VIEWOUTLETORDERREPORT"

export default function ViewOutletOrder() {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'View Outlet Order Outletwise'
    });

    const [datevalue, setDateValue] = useState(new Date());
    const [groupList, setGroupList] = useState([]);
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [isHidden, setIsHidden] = useState(false);
    const [outletDetails, setOutletDetails] = useState([]);
    const [value, setValue] = useState(0);

    const [formData, setFormData] = useState({
        groupID: '',
        operationEntityID: '',
        date: new Date(datevalue).toISOString()
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: '',
        outletName: '',
        date: ''
    });

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const classes = useStyles();

    const viewOutletOrderSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
        operationEntityID: Yup.number().min(1, 'Please Select Outlet').required('Outlet required'),
        date: Yup.date().min(1).min(1, 'Please Select Date').required('Date required')
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            date: formData.date
        },

        validationSchema: viewOutletOrderSchema,
        onSubmit: () => {
            trackPromise(SubmitForm());
            setIsHidden(true)
        }
    });

    function getSelectedDropdownValuesForReport() {


        let result = groupList.find((x) => x.groupID == formik.values.groupID)
        let res = operationEntityList.find((x) => x.factoryID == formik.values.operationEntityID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: result.groupName,
            outletName: res.factoryName,
            date: new Date(datevalue).toISOString().split('T')[0]

        });
    }
    async function SubmitForm() {
        let res = await services.GetViewOutletOrderOutletwise(
            formik.values.operationEntityID,
            new Date(datevalue).toISOString().split('T')[0]
        );
        setOutletDetails(res);
        createDataForExcel(res);
        getSelectedDropdownValuesForReport();

    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        //formik.resetForm()
        setOutletDetails([]);
        setDateValue(new Date());
    }
    async function createFile() {
        var file = await createDataForExcel(outletDetails);
        var settings = {
            sheetName: 'Outlet Order Outletwise Report',
            fileName: 'Outlet Order Outletwise Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Outlet Order Outletwise Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Product Name	': x.productName,
                    'Product Code	': x.productCode,
                    'Quantity	': x.quantity,

                }
                res.push(vr);
            });
        }
        return res;
    }

    useEffect(() => {
        getPermissions();
    }, [])

    useEffect(() => {
        GetAllGroups();
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWOUTLETORDERREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,

            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());

    }
    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        let res = await services.GetAllFactoriesByGroupID(formik.values.groupID);
        if (res != null) {
            setOperationEntityList(res);
        }
    }

    return (
        <>
            <LoadingComponent />
            <Page title="View Outlet Order Outletwise  |  FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                -                                               {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Outlet *"
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Outlet</MenuItem>
                                        {operationEntityList.map((option) => (
                                            <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DesktopDatePicker
                                            fullWidth
                                            size="small"
                                            label="Date *"
                                            openTo="day"
                                            type="date"
                                            inputFormat="MM/DD/YYYY"
                                            value={datevalue}
                                            onChange={(newValue) => {
                                                setDateValue(newValue);
                                            }}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button type="button" variant="outlined" color="error"
                                        onClick={() => clearAll()}
                                    >
                                        Clear
                                    </Button>
                                    <Button type="submit" color="secondary" variant="outlined"
                                    >
                                        Search
                                    </Button>
                                </Stack>
                                <br />
                                <Divider variant="middle" />
                                <br />
                                <>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                        {outletDetails.length != 0 ?
                                            <Card style={{ justifycontent: 'center', width: '85rem' }}>
                                                <Paper className={classes.root}>
                                                    <TableContainer component={Paper}>
                                                        <Table aria-label="collapsible table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Product Name</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Product Code</TableCell>
                                                                    <TableCell style={{ fontWeight: 'bold' }}>Quantity</TableCell>

                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {outletDetails.map((row, i) => (
                                                                    <TableRow key={i}>
                                                                        <TableCell >{row.productName}</TableCell>
                                                                        <TableCell >{row.productCode}</TableCell>
                                                                        <TableCell >{row.quantity}</TableCell>

                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>
                                            </Card> : null}
                                    </Stack>
                                    {outletDetails.length > 0 ?
                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                            <Button
                                                color="primary"
                                                id="btnRecord"
                                                type="button"
                                                variant="contained"
                                                style={{ marginRight: '1rem' }}
                                                className={classes.colorRecord}
                                                onClick={() => createFile()}
                                            >
                                                EXCEL
                                            </Button>
                                            <ReactToPrint
                                                documentTitle={"Outlet Order Oultletwise Report"}
                                                trigger={() => <Button
                                                    color="primary"
                                                    id="btnRecord"
                                                    type="button"
                                                    variant="contained"
                                                    style={{ marginRight: '1rem' }}
                                                    className={classes.colorCancel}
                                                    onClick={() => getSelectedDropdownValuesForReport()}
                                                >
                                                    PDF
                                                </Button>}
                                                content={() => componentRef.current}
                                            />
                                            <div hidden={true}>
                                                <CreatePDF ref={componentRef}
                                                    advancedPaymentList={outletDetails} searchData={selectedSearchValues}
                                                />
                                            </div>
                                        </Box> : null}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </Container>
            </Page>
        </>
    );
}